import React, { useState } from 'react';
import _ from 'lodash';

import AssetListContext from './assetListContext'
import { defaultAssetList } from "./defaultContext";

const AssetListProvider = ({children}) => {

  const setAssetDetails = ({
    currentPage,
    sortBy,
    openAssetDetails,
    selectedAssetHistoryTab,
    selectedAsset,
    assetList,
    assetFilters,
    filteredAssetList,
  }) => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};
      const mergedState = _.merge(newState, {
        currentPage,
        sortBy,
        openAssetDetails,
        selectedAssetHistoryTab,
        selectedAsset,
        assetList,
        assetFilters,
        filteredAssetList,
      })
      return mergedState;
    })
  };

  const updateOpenAssetDetails = (openAssetDetails: boolean) => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};
      const mergedState = _.merge(newState,{
        openAssetDetails
      });

      return mergedState;
    })
  };

  const updateSelectedAssetHistoryTab = (selectedAssetHistoryTab: string) => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};

      const mergedState = _.merge(newState, {
        selectedAssetHistoryTab,
      })

      return mergedState;
    })
  }

  const updateAssetList = (assetList: []) => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState}

      const mergedState = _.merge(newState, {
        assetList
      })

      return mergedState;
    })
  };

  const updateSort = (sortBy: string) => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};

      const mergedState = _.merge(newState, {
        sortBy
      });

      return mergedState;
    })
  };

  const updateFilters = ({conditionFilter, buildingFilter, underMaintenanceFilter}) => {
    updateAssetListDetails(prevState => {

      const newState = {...prevState};

      const assignState = _.assign(newState, {
        assetFilters: {
          conditionFilter,
          buildingFilter,
          underMaintenanceFilter
        }
      });

      return assignState
    })
  };

  const deleteFilters = () => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};

      const mergedState = _.merge(newState, {
        assetFilters: {
          conditionFilter: -1,
          buildingFilter: [],
          underMaintenanceFilter: [],
        }
      });

      return mergedState
    })
  };

  const clearAssetList = () => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};

      const assignState = _.assign(newState, {
        assetList: [],
        filteredAssetList: [],
      });

      return assignState;
    })
  };

  const updateFilteredAssetList = (newFilteredAssetList: []) => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};
      const assignState = _.assign(newState, {
        filteredAssetList: newFilteredAssetList,
      });
      return assignState;
    })
  };

  const deleteAllAssetInfo = () => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};

      return _.assign(newState,defaultAssetList)
    });
  };

  const updateAssetAttributes = (attributes: {
    AttributeID: string,
    Response: string,
    Variable: string,
  }[]) => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState};
      const selected = _.cloneDeep(newState.selectedAsset);
      const keys = ["CUSTREF1", "CUSTREF2", "MODEL", "VENDOR", "YEARMAN"];

      for(let attribute of attributes) {
        if(keys.includes(attribute.AttributeID)) {
          selected[attribute.AttributeID] = attribute.Response;
        }
      }

      return _.assign(newState,{selectedAsset: selected});
    })
  };

  const clearAssetDetails = () => {
    updateAssetListDetails(prevState => {
      const newState = {...prevState}

      const assignState = _.assign(newState, {
        selectedAsset: {
          CUSTREF1: '',
          CUSTREF2: '',
          MODEL: '',
          VENDOR: '',
          YEARMAN: '',
          ChargeFlag: '',
          Condition: 0,
          ContractNo: '',
          ContractSequence: 0,
          ContractSiteDesc: '',
          ContractTypeCode: '',
          ContractUnitNextServices: '',
          CustomerCode: '',
          InvoiceAmount: 0,
          InvoiceNo: 0,
          InvoicedDate: '',
          InvoicedFromDate: '',
          InvoicedToDate: '',
          ItemCode: '',
          ItemDescription: 'Please Select an Asset',
          Make: '',
          MakeCode: '',
          Rate: 0,
          SerialFlag: '',
          SerialInstallationDate: '',
          SerialLocationText: '',
          SerialNo: '',
          SerialStatusCode: '',
          SerialWarrantyDate: '',
          ServiceNo: '',
          UnitLocation: '',
          UnitLocationCode: '',
          UnitQty: 0,
        },
      });
      return assignState;
    })
  }

  const assetListState = {
    currentPage: '',
    openAssetDetails: false,
    assetHistoryTab: '',
    sortBy: '',
    selectedAsset: {
      CUSTREF1: '',
      CUSTREF2: '',
      MODEL: '',
      VENDOR: '',
      YEARMAN: '',
      ChargeFlag: '',
      Condition: 0,
      ContractNo: '',
      ContractSequence: 0,
      ContractSiteDesc: '',
      ContractTypeCode: '',
      ContractUnitNextServices: '',
      CustomerCode: '',
      InvoiceAmount: 0,
      InvoiceNo: 0,
      InvoicedDate: '',
      InvoicedFromDate: '',
      InvoicedToDate: '',
      ItemCode: '',
      ItemDescription: '',
      Make: '',
      MakeCode: '',
      Rate: 0,
      SerialFlag: '',
      SerialInstallationDate: '',
      SerialLocationText: '',
      SerialNo: '',
      SerialStatusCode: '',
      SerialWarrantyDate: '',
      ServiceNo: '',
      UnitLocation: '',
      UnitLocationCode: '',
      UnitQty: 0,
    },

    assetList: [],
    filteredAssetList: [],
    assetFilters: {
      conditionFilter: -1,
      buildingFilter: [],
      underMaintenanceFilter: [],
    },

    updateOpenAssetDetails,
    updateAssetList,
    updateSelectedAssetHistoryTab,
    setAssetDetails,
    clearAssetDetails,
    updateFilteredAssetList,
    updateSort,
    updateFilters,
    updateAssetAttributes,
    deleteFilters,
    clearAssetList,
    deleteAllAssetInfo,
  };

  const [assetListDetails, updateAssetListDetails] = useState(assetListState);

  return <AssetListContext.Provider value={assetListDetails}>{children}</AssetListContext.Provider>
};

export default AssetListProvider;
